import React, { useEffect, useState } from "react";
import LoginImg from "../assets/images/login-1.png";
import zithasLogo from "../assets/images/zithas-logo.avif";
import Otp from "./Otp";
import { FetchPostData } from "../config";
import Loader from "../components/Loader";
import Swal from "sweetalert2";
import secureLocalStorage from "react-secure-storage";

const Login = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const toggleLoading = (loading) => {
    setLoading(loading);
  };
  const onLoginSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      email: email,
    };
    const postData = await FetchPostData(
      toggleLoading,
      "otpVerification",
      "",
      formData
    );
    if (postData?.data?.success) {
      setIsFlipped(true)
      const user = {
        user_id: postData?.data?.user?.id,
        name: postData?.data?.user?.name,
        user_id: postData?.data?.user?.id,
        casual_leave: postData?.data?.user?.casual_leave,
        sick_leave: postData?.data?.user?.sick_leave,
        token: postData?.data?.token
      }
      secureLocalStorage.setItem("user", user)
      secureLocalStorage.setItem("otp", postData?.data?.otp)
    } else {
      Swal.fire({
        icon: "warning",
        text: "Oops! User Not Found 🙁"
      })
    }
  };

  useEffect(() => {
    const user = secureLocalStorage.getItem('user')
    const otp = secureLocalStorage.getItem('otp');
    if (otp != null && user != null) {
      setIsFlipped(true)
    }
  }, [])

  return (
    <>
      {loading && (<Loader />)}
      <div className="bg-light-purple">
        <div className="container h-100vh">
          <div>
            <div className="row h-100vh align-items-center">
              <div className="col-md-6 bd-responsive-none">
                <div>
                  <img src={LoginImg} alt="Login" className="" width="400" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-5">
                  <div className="mb-4 text-center">
                    <img src={zithasLogo} alt="Zithas Logo" width="230" />
                  </div>
                  {isFlipped == false && (
                    <div className="login-side text-center">
                      <h3 className="mb-2">Leave Management System</h3>
                      <p>Please log in to apply for leave </p>

                      <form
                        className="login-form mt-4 pt-3"
                        onSubmit={onLoginSubmit}
                      >
                        <div>
                          <div>
                            <label className="form-label">
                              Personal Email Address
                            </label>
                            <input
                              type="email"
                              placeholder="Enter Personal Email Address"
                              className="form-control custom-control"
                              required
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>

                          <div className="mt-5">
                            <button className="leave-button">
                              Login to your Account
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                  {isFlipped && <Otp />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
